module.exports = __webpack_public_path__ + "static/media/the-empire-strikes-back.3ecc21eb.png";